import React, { Component } from 'react';
import { Form, Input, Col, Row, message, Modal } from 'antd';
import { CustomRow, CustomCol } from '../../../../../../components/Custom';
import UploadFragment from '../../../../../Customer/components/ListAdd/UploadFragment'
import { config, postFrom } from '../../../../../../axios';
import moment from 'moment';

class BasicMessage extends Component {
    constructor() {
        super()
        this.state = {
            InputWidth: "185px",
            shortInputWidth: "135px",
            showPrevImg: false,
            prevImg: '',
            data: {}
        }
    }

    componentDidMount() {
        this.loadUserMsg()
    }

    loadUserMsg = () => { //基本信息详情
        this.setState({ loading: true });
        postFrom(
            {
                url: config.API_rentcontract_getRentContractByIdUserMsg,
                data: { rentContractId: this.props.id }
            }
        ).then(res => {
            this.setState({ loading: false, customerType: res.customerType, data: res });
        }).catch(err => {
            message.error(err.message || '获取详情失败');
            this.setState({ loading: false });
        });
    }

    render() {
        let { form: { getFieldDecorator } } = this.props;
        let {
            data,
        } = this.state;
        return (
            <div>
                <div className="custom" style={{ paddingBottom: "20px" }}>
                    <Form
                        labelCol={{ span: 0 }}
                        wrapperCol={{ span: 24 }}
                    >
                        {/* "marginLeft: index === 0 ? 0 : '15px' " */}
                        {
                            data.customerType ?
                                data.customerType === 2 ?
                                    <div>
                                        <Row>
                                            {
                                                data.attachList.map((item, index) => {
                                                    return (
                                                        <Col key={item.id} span={3} style={{ textAlign: 'center', marginTop: '15px', marginLeft: index === 0 ? 0 : "15px" }}>
                                                            <UploadFragment
                                                                index={1}
                                                                preview={item.fileUrl}
                                                                previewFn={(prevImg) => {
                                                                    this.setState({
                                                                        showPrevImg: true,
                                                                        prevImg
                                                                    })
                                                                }}
                                                                show={false}
                                                            />
                                                        </Col>
                                                    )
                                                })
                                            }
                                        </Row>
                                        <div style={{ height: "50px" }}></div>

                                        <Row>
                                            <Col>
                                                <CustomRow>
                                                    <CustomCol label="证件姓名" required={false} >
                                                        {getFieldDecorator('credentialName', {
                                                            rules: [{
                                                                required: false, message: '请输入',
                                                            }],
                                                            initialValue: data.credentialName
                                                        })(
                                                            <Input
                                                                placeholder={'请输入'} disabled={true}
                                                                autoComplete={'off'}
                                                            />
                                                        )}
                                                    </CustomCol>
                                                    <CustomCol label="身份证" required={false} >
                                                        {getFieldDecorator('credentialNumber', {
                                                            rules: [{
                                                                required: false, message: '请输入',
                                                            }],
                                                            initialValue: data.credentialNumber
                                                        })(
                                                            <Input
                                                                placeholder={'请输入'} disabled={true}
                                                                autoComplete={'off'}
                                                            />
                                                        )}
                                                    </CustomCol>
                                                    <CustomCol label="性别" required={false} >
                                                        {getFieldDecorator('gender', {
                                                            rules: [{
                                                                required: false, message: '请输入',
                                                            }],
                                                            initialValue: data.gender === 1 ? '男' : data.gender === 2 ? '女' : null
                                                        })(
                                                            <Input
                                                                placeholder={'请输入'} disabled={true}
                                                                autoComplete={'off'}
                                                            />
                                                        )}
                                                    </CustomCol>
                                                </CustomRow>
                                                <CustomRow divider>
                                                    <CustomCol label="出生日期" required={false} >
                                                        {getFieldDecorator('birth', {
                                                            rules: [{
                                                                required: false, message: '请输入',
                                                            }],
                                                            initialValue: data.birth ? moment(data.birth).format('YYYY-MM-DD') : null
                                                        })(
                                                            <Input
                                                                placeholder={'请输入'} disabled={true}
                                                                autoComplete={'off'}
                                                            />
                                                        )}
                                                    </CustomCol>
                                                    <CustomCol label="民族" required={false} >
                                                        {getFieldDecorator('national', {
                                                            rules: [{
                                                                required: false, message: '请输入',
                                                            }],
                                                            initialValue: data.national
                                                        })(
                                                            <Input
                                                                placeholder={'请输入'} disabled={true}
                                                                autoComplete={'off'}
                                                            />
                                                        )}
                                                    </CustomCol>

                                                </CustomRow>
                                                <CustomRow divider>
                                                    <CustomCol label="证件住址" required={false} colStyle={{ width: "500px" }} >
                                                        {getFieldDecorator('credentialAddress', {
                                                            rules: [{
                                                                required: false, message: '请输入',
                                                            }],
                                                            initialValue: data.credentialAddress
                                                        })(
                                                            <Input
                                                                placeholder={'请输入'} disabled={true}
                                                                autoComplete={'off'}
                                                            // style={{ width: "371px" }}
                                                            />
                                                        )}
                                                    </CustomCol>
                                                </CustomRow>
                                                <CustomRow divider>
                                                    <CustomCol label="发证机关" required={false} >
                                                        {getFieldDecorator('credentialIssuedBy', {
                                                            rules: [{
                                                                required: false, message: '请输入',
                                                            }],
                                                            initialValue: data.credentialIssuedBy
                                                        })(
                                                            <Input
                                                                placeholder={'请输入'} disabled={true}
                                                                autoComplete={'off'}
                                                            />
                                                        )}
                                                    </CustomCol>
                                                    <CustomCol label="证件有效期" required={false} >
                                                        {getFieldDecorator('credentialValidDate1', {
                                                            rules: [{
                                                                required: false, message: '请输入',
                                                            }],
                                                            initialValue: data.credentialValidDate1 && data.credentialValidDate2 ? `${moment(data.credentialValidDate1).format('YYYY-MM-DD')} - ${moment(data.credentialValidDate2).format('YYYY-MM-DD')}` : null
                                                        })(
                                                            <Input
                                                                placeholder={'请输入'} disabled={true}
                                                                autoComplete={'off'}
                                                            />
                                                        )}
                                                    </CustomCol>
                                                </CustomRow>
                                            </Col>
                                        </Row>
                                    </div>
                                    : data.customerType === 1 ?


                                        <Row>
                                            <Row>
                                                {
                                                    data.attachList.map((item, index) => {
                                                        return (
                                                            <Col key={item.id} span={3} style={{ textAlign: 'center', marginTop: '15px', marginLeft: index === 0 ? 0 : "15px" }}>
                                                                <UploadFragment
                                                                    index={1}
                                                                    preview={item.fileUrl}
                                                                    previewFn={(prevImg) => {
                                                                        this.setState({
                                                                            showPrevImg: true,
                                                                            prevImg
                                                                        })
                                                                    }}
                                                                    show={false}
                                                                />
                                                            </Col>
                                                        )
                                                    })
                                                }
                                                {/* <Col key={1} span={3} style={{ textAlign: 'center', marginTop: '15px', marginLeft: 0 === 0 ? 0 : "15px"}}>
                                        <UploadFragment
                                            index={1}
                                            preview={"http://img.zcool.cn/community/01a7ea57aae9500000018c1b2c8284.jpg@2o.jpg"}
                                            previewFn={(prevImg) => {
                                                this.setState({
                                                    showPrevImg: true,
                                                    prevImg
                                                })
                                            }}
                                            deleteFn={this.handleDeleteAttach}
                                            show={false}
                                        />
                                    </Col>   */}
                                            </Row>
                                            <div style={{ height: '40px' }}></div>
                                            <Row>
                                                <Col>
                                                    <CustomRow>
                                                        <CustomCol label="企业名称" required={false} >
                                                            {getFieldDecorator('credentialName', {
                                                                rules: [{
                                                                    required: false, message: '请输入',
                                                                }],
                                                                initialValue: data.credentialName
                                                            })(
                                                                <Input
                                                                    placeholder={'请输入'} disabled={true}
                                                                    autoComplete={'off'}
                                                                />
                                                            )}
                                                        </CustomCol>
                                                    </CustomRow>
                                                    <CustomRow divider>
                                                        <CustomCol label="证件号码" required={false} >
                                                            {getFieldDecorator('credentialNumber', {
                                                                rules: [{
                                                                    required: false, message: '请输入',
                                                                }],
                                                                initialValue: data.credentialNumber
                                                            })(
                                                                <Input
                                                                    placeholder={'请输入'} disabled={true}
                                                                    autoComplete={'off'}
                                                                />
                                                            )}
                                                        </CustomCol>
                                                    </CustomRow>
                                                </Col>
                                            </Row>
                                        </Row>

                                        : ""
                                : ""
                        }
                    </Form>
                </div>
                <Modal
                    title="预览图片"
                    visible={this.state.showPrevImg}
                    footer={null}
                    onCancel={() => {
                        this.setState({
                            showPrevImg: false,
                            prevImg: ''
                        })
                    }}
                    width={800}
                    centered={true}
                >
                    <div style={{ textAlign: 'center', maxWidth: '1000px', maxHeight: '600px', padding: '20px' }}>
                        <img src={this.state.prevImg} style={{ width:'100%' }} />
                    </div>
                </Modal>
            </div>

        )
    }
}

export default Form.create()(BasicMessage)


// WEBPACK FOOTER //
// ./src/page/RentContract/components/List/details/BasicMessage/index.js